import { render, staticRenderFns } from "./log.vue?vue&type=template&id=2f06dd08&scoped=true"
import script from "./log.vue?vue&type=script&setup=true&lang=js"
export * from "./log.vue?vue&type=script&setup=true&lang=js"
import style0 from "./log.vue?vue&type=style&index=0&id=2f06dd08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06dd08",
  null
  
)

export default component.exports